const handleViewEvent = (event) => {
    const { visibility } = event;
    if (visibility && visibility.value && visibility.unit) {
        return visibility.unit === 'PIXEL'
            ? visibility.value
            : (visibility.value / 100) * window.innerHeight;
    }
    throw new Error('No visibility value or unit present in the response');
};

const getVisibilityValue = (module) => {
    try {
        // Lazy module need to have an event, eventType and callback to act upon
        if (module && module.event && module.event.type) {
            const { event } = module;
            // Switch case to accomodate new event types (delay and refresh for example)
            // eslint-disable-next-line default-case
            switch (event.type) {
                case 'View': {
                    try {
                        return handleViewEvent(event);
                    } catch (error) {
                        throw error;
                    }
                }
            }
        } else {
            throw new Error('Incoming module does not have event, callback or type or event');
        }
    } catch (err) {
        throw err;
    }
};

const isInViewport = (element, visibilityValue) => {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 - visibilityValue &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};

module.exports = {
    getVisibilityValue,
    isInViewport
};
